import { RavenInsertMeta } from './sentry';
const rvTrack = (event, attr = {}) => RavenInsertMeta('Workspace', event, attr);
export default function track(action, attr) {
    rvTrack(action, attr);
}
export { rvTrack, };
